import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import type React from 'react';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import type {
  AdminCanaryTokensDialogProps,
  CanaryTokenFormFields
} from './AdminCanaryTokens.types';
import { AdminCanaryTokensDialogForm } from './AdminCanaryTokensDialogForm';

const AdminCanaryTokensDialog: React.FC<AdminCanaryTokensDialogProps> = ({
  open,
  onClose,
  editingToken,
  onSubmit
}) => {
  const methods = useForm<CanaryTokenFormFields>({
    defaultValues: {
      token: '',
      description: '',
      active: true
    },
    mode: 'onChange'
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid }
  } = methods;

  useEffect(() => {
    if (editingToken) {
      reset({
        token: editingToken.token,
        description: editingToken.description || '',
        active: editingToken.active ?? true
      });
    }
  }, [editingToken, reset]);

  const handleFormSubmit = (data: CanaryTokenFormFields) => {
    onSubmit(data);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Canarytoken</DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        <FormProvider {...methods}>
          <AdminCanaryTokensDialogForm />
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit(handleFormSubmit)}
          variant="contained"
          disabled={!isValid}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminCanaryTokensDialog;
